import { useEffect, useState } from "react";
import "../pagescss/Header.css";
import logo from "../assets/logo.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_URL } from "./apiConfig";


const Header = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [Error, setError] = useState("")

  const handle = () => {
    navigate("/profile");
  };

  //
  //
  const userId = JSON.parse(localStorage.getItem("no-msisdn"));

  useEffect(() => {
    const fetchUsername = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/api/user/username/${userId}`
        );
        setUsername(response.data.username);
      } catch (err) {
        console.error("Error fetching username:", err);
        setError("Failed to fetch username.");
      }
    };

    if (userId) {
      fetchUsername();
    }
  }, [userId]);
  //
  //

  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : "U";
  };

  return (
    <header className="header-game">
      <div className="header-logo">
        <img src="https://casual.gamenow.com.pk/assets/images/logo%20(1).png" alt="Game-Now"></img>
      </div>
      <div
        className="header-user-icon"
        onClick={handle}
        style={{ cursor: "pointer" }}
      >
        <div className="profile-circle-header">
          <span className="initial-text-header">{getInitial(username)}</span>
        </div>
        {/* <img src={userIcon} alt="User Icon" /> */}
      </div>
    </header>
  );
};

export default Header;
